import { render } from "./InicioClientes.vue?vue&type=template&id=7920ba9a&scoped=true"
import script from "./InicioClientes.vue?vue&type=script&lang=js"
export * from "./InicioClientes.vue?vue&type=script&lang=js"

import "./InicioClientes.vue?vue&type=style&index=0&id=7920ba9a&lang=scss&scoped=true"

import exportComponent from "/Users/coolio/Documents/proyectos/karga/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7920ba9a"]])

export default __exports__